module.exports = "pegasus_template/assets/tech/safari/102.png";